import { render, staticRenderFns } from "./addBtn_plus.vue?vue&type=template&id=3681ddec&scoped=true"
import script from "./addBtn_plus.vue?vue&type=script&lang=js"
export * from "./addBtn_plus.vue?vue&type=script&lang=js"
import style0 from "./addBtn_plus.vue?vue&type=style&index=0&id=3681ddec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3681ddec",
  null
  
)

export default component.exports